/**
 * Copyright 2019 Atelier Disko. All rights reserved. This source
 * code is distributed under the terms of the BSD 3-Clause License.
 */

import React, { useState } from 'react';
import jwtDecode from 'jwt-decode';
import './JWTDecoder.css';
import CodeBlock from '../dpa-CodeBlock';

function JWTDecoder() {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(null);

  let payload = null;

  if (data) {
    payload = Object.keys(data).map(key => {
      return (
        <ul>
          <li>
            <strong>{key}</strong>: {data[key]}
          </li>
        </ul>
      );
    });
  }

  let isValid = !error && data !== undefined;
  let isInvalid = error && data !== undefined;

  return (
    <div className="jwt-decoder">
      <textarea
        className="jwt-decoder__input"
        onChange={event => {
          if (event.target.value.length <= 0) {
            setError(null);
            setData(undefined);
            return;
          }

          try {
            setData(JSON.stringify(jwtDecode(event.target.value), null, 2));
            setError(null);
          } catch (error) {
            setError(error.message);
            setData(null);

            return;
          }
        }}
        placeholder="Your JWT"
      />

      <CodeBlock language="js">{data || error || 'Please paste a JWT.'}</CodeBlock>

        <div className={`jwt-decoder__validation ${isValid ? 'jwt-decoder__validation--is-valid' : ''} ${isInvalid ? 'jwt-decoder__validation--is-invalid' : ''}`}>
          {isValid ? '✓ Your token is valid' : ''}
          {isInvalid ? '× Your token is invalid' : ''}
        </div>

      {/* {payload}
      {error && <p>{error}</p>} */}
    </div>
  );
}

export default JWTDecoder;
